import { render, staticRenderFns } from "./LifestyleBase.vue?vue&type=template&id=da57a14a"
import script from "./LifestyleBase.vue?vue&type=script&lang=js"
export * from "./LifestyleBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports